import { render, staticRenderFns } from "./Rmas.vue?vue&type=template&id=6abf1b17"
import script from "./Rmas.vue?vue&type=script&lang=js"
export * from "./Rmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports